import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = {
  class: "section",
  id: "school-confirmation"
}
const _hoisted_2 = { class: "info-section" }
const _hoisted_3 = { class: "info-title" }
const _hoisted_4 = { class: "info" }
const _hoisted_5 = { class: "info-section" }
const _hoisted_6 = { class: "info-title" }
const _hoisted_7 = {
  key: 0,
  class: "info"
}
const _hoisted_8 = { class: "amount" }
const _hoisted_9 = { class: "term" }
const _hoisted_10 = { class: "info-section" }
const _hoisted_11 = { class: "info-title" }
const _hoisted_12 = { class: "info" }
const _hoisted_13 = { class: "info-section" }
const _hoisted_14 = { class: "info-title" }
const _hoisted_15 = { class: "info" }
const _hoisted_16 = { class: "info-section" }
const _hoisted_17 = { class: "info-title" }
const _hoisted_18 = { class: "info" }
const _hoisted_19 = {
  key: 0,
  class: "info-section"
}
const _hoisted_20 = { class: "info-title" }
const _hoisted_21 = { class: "info" }
const _hoisted_22 = {
  key: 1,
  class: "info-section"
}
const _hoisted_23 = { class: "info-title" }
const _hoisted_24 = { class: "info" }
const _hoisted_25 = { key: 0 }

import { useStore } from "vuex";
import useApplicationInfo from "@/composables/application-info/useApplicationInfo";
import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'CurrentRequestForFunds',
  props: {
    loading: { type: Boolean, default: false }
  },
  emits: ["openSchoolConfirmationModal", "openBorrowAmountModal", "openLoanOptionsModal"],
  setup(__props: any, { emit: __emit }) {

const store = useStore();



const emit = __emit;

const {
  details,
  disbursements,
  editable,
  formatMoney,
  monthlyInSchoolPaymentLabel,
  monthlyPostSchoolPaymentLabel,
  rateSelectionDisplay,
  repaymentTypeDisplay,
  requestedAmount,
  schoolName,
  showEstimatedMonthlyPayments,
} = useApplicationInfo();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _mergeProps({ id: "your-current-request" }, _ctx.$attrs, {
    class: __props.loading ? 'hide' : ''
  }), [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, [
          _cache[5] || (_cache[5] = _createTextVNode(" School  ", -1)),
          (_unref(editable))
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "edit-link edit-loan-config-link",
                href: "#/",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('openSchoolConfirmationModal', true)))
              }, "Edit"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", null, _toDisplayString(_unref(schoolName)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", _hoisted_6, [
          _cache[6] || (_cache[6] = _createTextVNode(" Academic Terms  ", -1)),
          (_unref(editable))
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: "#/",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('openSchoolConfirmationModal', true))),
                class: "edit-link edit-loan-config-link"
              }, "Edit"))
            : _createCommentVNode("", true)
        ]),
        (_unref(disbursements).length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(disbursements), (disbursement, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "disbursement"
                }, [
                  _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(formatMoney)(disbursement.amount)), 1),
                  _createElementVNode("p", _hoisted_9, _toDisplayString(disbursement.term || 'Not Yet Selected'), 1)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("p", _hoisted_11, [
        _cache[7] || (_cache[7] = _createTextVNode(" Funds Requested for Academic Term  ", -1)),
        (_unref(editable))
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "edit-link edit-loan-config-link",
              href: "#/",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('openBorrowAmountModal', true)))
            }, "Edit"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(requestedAmount)), 1)
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("p", _hoisted_14, [
        _cache[8] || (_cache[8] = _createTextVNode(" Interest Rate  ", -1)),
        (_unref(editable))
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "edit-link edit-loan-config-link",
              href: "#/",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('openLoanOptionsModal', true)))
            }, "Edit"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("p", null, _toDisplayString(_unref(rateSelectionDisplay)), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("p", _hoisted_17, [
        _cache[9] || (_cache[9] = _createTextVNode(" Repayment Type  ", -1)),
        (_unref(editable))
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "edit-link edit-loan-config-link",
              href: "#/",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (emit('openLoanOptionsModal', true)))
            }, "Edit"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("p", null, _toDisplayString(_unref(repaymentTypeDisplay) || "Not Yet Selected"), 1)
      ])
    ]),
    (_unref(showEstimatedMonthlyPayments))
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("p", _hoisted_20, " Estimated Monthly " + _toDisplayString(_unref(monthlyInSchoolPaymentLabel)) + " Payments ", 1),
          _createElementVNode("div", _hoisted_21, [
            _createTextVNode(_toDisplayString(_unref(details)?.monthlyInSchoolPaymentsDisplay) + " ", 1),
            (_unref(details)?.monthlyInSchoolPaymentsDisplay !== 'Not Yet Selected')
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass(__props.loading ? 'hide' : '')
                }, "/ Month", 2))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(showEstimatedMonthlyPayments))
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _createElementVNode("p", _hoisted_23, " Estimated Monthly " + _toDisplayString(_unref(monthlyPostSchoolPaymentLabel)) + " Payments ", 1),
          _createElementVNode("div", _hoisted_24, [
            _createTextVNode(_toDisplayString(_unref(details)?.monthlyPostGradPaymentsDisplay) + " ", 1),
            (_unref(details)?.monthlyPostGradPaymentsDisplay !== 'Not Yet Selected')
              ? (_openBlock(), _createElementBlock("span", _hoisted_25, "/ Month"))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 16))
}
}

})